module.exports = __webpack_public_path__ + "img/HPS012CP.62f94afa.png";